import gql from "graphql-tag";

export default gql`
  mutation($orderIds: [ID!], $printFiles: [OrderPrintFileInput!]) {
    uploadPrintFile(orderIds: $orderIds, printFiles: $printFiles)
  }
`;
